import { Grid, Typography } from "@material-ui/core";

export const XAxis = () => (
  <Grid container>
    <Grid item xs={6}>
      <Typography align="center">Portfolio average</Typography>
    </Grid>
    <Grid item xs={6}>
      <Typography align="center">This building with new power assets</Typography>
    </Grid>
  </Grid>
);
